import IMask from 'imask';
import { mount } from '../dom-lifecycle';

// Polskie pole telefonu: maska 000-000-000 (9 cyfr, bez prefiksu kraju).
// Problem do rozwiązania: użytkownik wkleja numer z prefiksem (48..., +48..., 0048...),
// a zwykła maska bierze pierwsze 9 cyfr i ucina prawdziwą końcówkę.
// Rozwiązanie: z wklejonej/autouzupełnionej wartości bierzemy same cyfry,
// a z nich OSTATNIE 9 — prefiks 48/0048 zostaje odrzucony.
mount('[data-phone-pl]', function () {
	let imask = this._imask = new IMask(this, { mask: '000-000-000' });

	let last9 = raw => (raw || '').replace(/\D/g, '').slice(-9);

	$(this).on('input', () => imask.value = this.value);

	this.addEventListener('paste', e => {
		e.preventDefault();
		let text = (e.clipboardData || window.clipboardData).getData('text');
		imask.value = last9(text);
	});

	// Autouzupełnienie przeglądarki wstawia całą wartość naraz (np. +48 123 456 789).
	$(this).on('change', () => {
		let digits = this.value.replace(/\D/g, '');
		if (digits.length > 9) imask.value = last9(digits);
	});

	$(this.form).on('reset', () => imask.masked.reset());
	let update = () => $(this).toggleRuleValid('mask', imask.masked.isComplete);
	imask.on('accept', update);
	update();
});
